var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259,
    height: 363,
    viewBox: "0 0 259 363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3E3E3E",
    d: "M212.65 78.676l-41.305-41.3 34.324-34.32C197.524.73 189.379-.433 180.07.149c-32.578 2.909-58.758 31.993-58.176 64.568 0 6.399 1.163 12.797 2.909 18.614L13.105 182.217c-16.87 14.543-17.453 40.719-1.745 56.424 15.708 15.706 41.305 15.124 56.431-1.745l98.9-111.684c9.89 2.908 20.943 4.072 32.578 1.745 23.271-4.654 42.47-22.104 48.869-44.79 2.908-13.38 2.327-26.176-1.164-37.81l-34.324 34.32z",
    transform: "translate(-965 -156) translate(970 160)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#565656",
    d: "M111.932 4.477l2.39 28.677c8.055 1.818 15.573 4.997 22.347 9.277h0l21.983-18.603 18.997 18.997-18.603 21.984c4.276 6.77 7.46 14.291 9.277 22.346h0L197 89.545v26.864l-28.677 2.391c-1.818 8.055-4.997 15.572-9.277 22.346h0l18.603 21.983-18.997 18.998-21.983-18.604c-6.77 4.276-14.292 7.46-22.346 9.277h0l-2.391 28.677H85.068l-2.39-28.677c-8.055-1.817-15.573-4.996-22.347-9.277h0l-21.983 18.603L19.35 163.13l18.603-21.983c-4.276-6.77-7.46-14.291-9.277-22.346h0L0 116.41V89.544l28.677-2.39c1.818-8.055 4.997-15.572 9.277-22.346h0L19.35 42.825l18.997-18.997L60.33 42.431c6.77-4.276 14.292-7.459 22.346-9.277h0l2.391-28.677h26.864zM98.5 76.114c-14.838 0-26.864 12.026-26.864 26.863 0 14.838 12.026 26.864 26.864 26.864 14.838 0 26.864-12.026 26.864-26.864 0-14.837-12.026-26.863-26.864-26.863z",
    transform: "translate(-965 -156) translate(970 160) translate(26 153)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A3D",
    d: "M197 26.864L170.136 0",
    transform: "translate(-965 -156) translate(970 160) translate(26 153)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.85d164357afe08ace773737a297deac5.svg";
export { ForwardRef as ReactComponent };